// Reusable WYSIWYG formatting toolbar for contenteditable editors.
// Uses document.execCommand for bold, italic, strike, underline, code, link, lists.
// Usage: WysiwygToolbar: {} — place near a contenteditable element.

// smbls 3.14.x — FA-L11 fix landed; top-level `title` + `aria: { label }`
// now reach the <button>. No more `attr: { ... }` wrapper needed for
// icon-only buttons.
const _btn = (icon, title, cmd) => ({
  extends: 'NavbarButton',
  padding: 'Y2',
  title,
  aria: { label: title },
  color: 'caption',
  ':hover': { color: 'title', background: 'overlay' },
  Icon: { icon },
  onMouseDown: (e) => {
    e.preventDefault()
    e.stopPropagation()
    document.execCommand(cmd)
  },
  onClick: (e) => e.preventDefault()
})

export const WysiwygToolbar = {
  flow: 'x',
  gap: 'V',
  align: 'center left',

  Bold: _btn('bold', 'Bold', 'bold'),
  Italic: _btn('italic', 'Italic', 'italic'),
  Strike: _btn('strikethrough', 'Strikethrough', 'strikeThrough'),
  Underline: _btn('underline', 'Underline', 'underline'),

  Code: {
    extends: 'NavbarButton',
    padding: 'Y2',
    title: 'Code',
    aria: { label: 'Code' },
    color: 'caption',
    ':hover': { color: 'title', background: 'overlay' },
    Icon: { icon: 'code' },
    onMouseDown: (e) => {
      e.preventDefault()
      e.stopPropagation()
      const sel = window.getSelection()
      if (!sel || !sel.rangeCount || sel.isCollapsed) return
      try {
        const code = document.createElement('code')
        code.style.cssText = 'font-family:monospace;background:rgba(255,255,255,0.08);padding:1px 4px;border-radius:3px'
        sel.getRangeAt(0).surroundContents(code)
        sel.collapseToEnd()
      } catch {}
    },
    onClick: (e) => e.preventDefault()
  },

  Link: {
    extends: 'NavbarButton',
    padding: 'Y2',
    title: 'Link',
    aria: { label: 'Link' },
    color: 'caption',
    ':hover': { color: 'title', background: 'overlay' },
    Icon: { icon: 'link' },
    onMouseDown: (e) => {
      e.preventDefault()
      e.stopPropagation()
      const sel = window.getSelection()
      const saved = sel?.rangeCount ? sel.getRangeAt(0).cloneRange() : null
      const url = prompt('URL:')
      if (!url) return
      if (saved) { sel.removeAllRanges(); sel.addRange(saved) }
      document.execCommand('createLink', false, url)
    },
    onClick: (e) => e.preventDefault()
  },

  Quote: _btn('quote', 'Blockquote', 'formatBlock'),
  BulletList: _btn('menu', 'Bullet list', 'insertUnorderedList'),
  NumberList: _btn('listOrdered', 'Numbered list', 'insertOrderedList'),
  Divider: _btn('minus', 'Divider', 'insertHorizontalRule')
}
